import { useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import useInvoiceHook from "./useInvoice";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { CURRENCY_SYMBOLS } from "./components/constant";
import SendToCustomerModal from "./sendToCustomerModal";

const Invoicedetails = () => {
  const [menu, setMenu] = useState(false);
  const { id } = useParams();
  const invoiceData = window.INVOICE
  const company = window.COMPANY;

  const { FetchSingleInvoice } = useInvoiceHook();
  const { invoice } = FetchSingleInvoice(id);
  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <>
          <div className="page-wrapper ">
            <div className="content container-fluid">
              <div className="card">
                <div className="card-body">
                  <div className="page-header">
                    <div className="content-invoice-header">
                      <h5>Invoice Details</h5>
                      <div className="list-btn">
                        <a
                          className="btn btn-primary"
                          href={`/invoice/${invoice?.id}/send-email/`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            marginRight: 10,
                          }}
                        >
                          View Invoice
                        </a>
                        <button
                          className="btn btn-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#paynow_modal"
                        >
                          Send to customer
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className="invoice-card">
                        <div className="card-bod">
                          <div className="card-table">
                            <div className="card-bod">
                              {/* Invoice Logo */}
                              <div className="invoice-item invoice-item-one">
                                <div className="row align-items-center">
                                  <div className="col-md-6">
                                    <div className="invoice-logo">
                                      <img
                                        className="light-color-logo"
                                        src={company?.company_icon}
                                        alt="logo"
                                      />
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="invoice-info">
                                      <h1 className="text-warning">
                                        {invoice?.status?.label}
                                      </h1>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice Logo */}
                              {/* Invoice Date */}
                              <div className="invoice-item invoice-item-date">
                                <div className="row">
                                  <div className="col-md-4">
                                    <p className="text-start invoice-details">
                                      Issue Date<span>: </span>
                                      <strong>
                                        {invoice?.invoice_formatted_date}
                                      </strong>
                                    </p>
                                  </div>
                                  <div className="col-md-4">
                                    <p className="invoice-details">
                                      Invoice No<span>: </span>
                                      <strong>
                                        #{invoice?.invoice_number}
                                      </strong>
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice Date */}
                              {/* Invoice To */}
                              <div className="invoice-item invoice-item-two">
                                <div className="row">
                                  <div className="col-md-4">
                                    <div className="invoice-info mb-3">
                                      <strong className="customer-text-one">
                                        Invoiced To<span>:</span>
                                      </strong>
                                      <p className="invoice-details-two">
                                        {invoice?.customer?.user?.full_name}
                                        {/* <br />
                                        15 Hodges Mews, High Wycombe
                                        <br />
                                        HP12 3JL
                                        <br />
                                        United Kingdom */}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="col-md-4">
                                    <div className="invoice-info invoice-info2 mb-3"></div>
                                  </div>
                                  <div className="col-md-4">
                                    {/* <div className="invoice-info invoice-info2 mb-3">
                                      <strong className="customer-text-one">
                                        Payment Details<span>:</span>
                                      </strong>
                                      <p className="text-start invoice-details-two invoice-details mb-1">
                                        PayPal<span>: </span>
                                        <strong>examplepaypal.co</strong>
                                      </p>
                                      <p className="text-start invoice-details-two invoice-details mb-1">
                                        Account<span>: </span>
                                        <strong>examplepaypal.co</strong>
                                      </p>
                                      <p className="text-start invoice-details-t invoice-details">
                                        Paymnt Term<span>: </span>
                                        <strong>15 days</strong>
                                        <span className="text-danger">
                                          Due in 8 days
                                        </span>
                                      </p>
                                      <div className="pay-btn">
                                        <Link
                                          to="#"
                                          className="btn btn-primary mt-2"
                                          data-bs-toggle="modal"
                                          data-bs-target="#paynow_modal"
                                        >
                                          Pay Now
                                        </Link>
                                      </div>
                                    </div> */}
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice To */}
                              {/* Invoice Item */}
                              <div className="invoice-item invoice-table-wrap">
                                <div className="invoice-table-head"></div>
                                <div className="row">
                                  <div className="col-md-12">
                                    <div className="table-responsive">
                                      <table className="table table-center table-hover mb-0">
                                        <thead className="thead-light">
                                          <tr>
                                            <th>Product</th>
                                            <th>Quantity</th>
                                            <th>Unit</th>
                                            <th>Rate</th>
                                            <th>Discount</th>
                                            <th>Amount</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {invoice?.invoice_products?.map(
                                            (item, key) => {
                                              return (
                                                <tr key={key}>
                                                  <td  style={{
                                                      maxWidth: 300,
                                                      textWrap : 'auto'
                                                    }}>{item?.label}</td>
                                                  <td>{item?.quantity}</td>
                                                  <td>{item?.unit}</td>
                                                  <td>
                                                    {
                                                      CURRENCY_SYMBOLS[
                                                        invoice?.customer
                                                          ?.currency_type
                                                      ]
                                                    }{" "}
                                                    {item?.rate}
                                                  </td>
                                                  <td>{item.discount} %</td>
                                                  <td>
                                                    {
                                                      CURRENCY_SYMBOLS[
                                                        invoice?.customer
                                                          ?.currency_type
                                                      ]
                                                    }{" "}
                                                    {item?.amount}
                                                  </td>
                                                </tr>
                                              );
                                            }
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* /Invoice Item */}
                              {/* Terms & Conditions */}
                              <br />
                              <hr />
                              <div className="terms-conditions">
                                <br />

                                <div className="row align-items-center justify-content-between">
                                  <div className="col-lg-6 col-md-6">
                                    <div
                                      className="invoice-terms"
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span className="invoice-terms-icon bg-white-smoke me-3">
                                        <i className="fe fe-file-text" />
                                      </span>
                                      <div className="invocie-note">
                                        <h6>Terms &amp; Conditions</h6>
                                        <p className="mb-0">{invoice?.terms}</p>
                                      </div>
                                    </div>
                                    <div
                                      className="invoice-terms "
                                      style={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <span className="invoice-terms-icon bg-white-smoke me-3">
                                        <i className="fe fe-file-minus" />
                                      </span>
                                      <div className="invocie-note">
                                        <h6>Note</h6>
                                        <p className="mb-0">{invoice?.notes}</p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-5 col-md-6">
                                    <div className="invoice-total-card">
                                      <div className="invoice-total-box">
                                        <div className="invoice-total-inner"></div>
                                        <div className="invoice-total-footer">
                                          <h4>
                                            Total Amount{" "}
                                            <span>
                                              {
                                                CURRENCY_SYMBOLS[
                                                  invoice?.customer
                                                    ?.currency_type
                                                ]
                                              }{" "}
                                              {invoice?.total_invoice_amount}
                                            </span>
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr />
                              <div className="invoice-sign text-end">
                                <span className="d-block">Authorised Sign</span>
                                <img
                                  className="img-fluid d-inline-block light-color-logo"
                                  src={invoiceData?.digital_signature_image}
                                  alt="sign"
                                  
                                  style={{
                                    maxHeight : 100,
                                    maxWidth : 100
                                  }}
                                />
                               
                              </div>
                              {/* /Terms & Conditions */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SendToCustomerModal invoice={invoice} />
        </>
      </div>
    </>
  );
};

export default Invoicedetails;
